// @ts-check

import React, { useEffect, useRef, useState } from 'react';

import { jsxActions as liveMapJsxActions } from '../../actions/LiveMap/liveMapPageActions';
import usePrepareMap from './Hooks/usePrepareMap';
import useHandleServerData from './Hooks/useHandleServerData';
import useHandleMapClick from './Hooks/useHandleMapClick';
import useLoadMapSettings from './Hooks/useLoadMapSettings';
import useInitializeMap from './Hooks/useInitializeMap';
import MapLevelSelectorOverlay from './Components/mapLevelSelectorOverlay';
import MapToolbarOverlay from './Components/mapToolbarOverlay';
import MapCameraPresetsOverlay from './Components/mapCameraPresetsOverlay';
import useFetchFullStatus from './Hooks/useFetchFullStatus';
import useRenderFullStatus from './Hooks/useRenderFullStatus';



require('./liveMapPage.scss');
require('./mappedin.scss');



/**
 * @typedef {import("./liveMapPageTypes").LiveMapPageProps} LiveMapPageProps
 * 
 * @typedef {import("@mappedin/mappedin-js").TShowVenueOptions} TShowVenueOptions
 * @typedef {import("@mappedin/mappedin-js").TGetVenueOptions} TGetVenueOptions
 * 
*/



// https://developer.mappedin.com/web-sdk/v5/using-react



/**
 * @param {LiveMapPageProps} props
 */
const LiveMapPage = (props) => {
  
  let { sData } = props;
  
  console.log(`=========== PAGE RENDER ===> {` + sData.toJS().activeMapSetting?.name + `}`, props);
  //sData.toJS().activeMapSetting.name;
  // console.log('props ===> ', props);
  // console.log('sData ===> ', sData);



  //////////////////////////////////////////////
  // Trigger map settings load from server.
  //
  useLoadMapSettings(props, [props.match.params.mapId]);



  /** 
   * @type {React.MutableRefObject<HTMLDivElement | null>}
   */
  const mapHtmlTargetRef = useRef(null);
  const [venue, mapView] = useInitializeMap(mapHtmlTargetRef, props);


  
  // if (mapView) {
  //   mapView.Camera.on(E_CAMERA_EVENT.CHANGED, (e) => {
  //     console.log('camera changed! ===> ', e.zoom);
  //   });
  // }
  


  //////////////////////////////////////////////
  // Trigger full status load from server.
  //
  let [startTimer_FetchFullStatus, stopTimer_FetchFullStatus] = useFetchFullStatus(props, mapView);
  startTimer_FetchFullStatus();



  ///////////////////////////////////
  // Map logic initialization.
  // 
  // Color map elements and make them interactive.
  //
  // Returns a function that can be used to reset map colors.
  //
  let [recolorMap] = usePrepareMap(mapView);



  ///////////////////////////////////////////
  // Add a click handler to the map.
  // 
  // Map interaction results in messages to the store via props.actions.
  // But not limited to that.
  //
  let [refCurrentMapNode] = useHandleMapClick(mapView, props);

  
  //////////////////////////////////////////////
  // Render full status, aka normal mode.
  //
  // let refCurrentMapNode = React.useRef(null);
  useRenderFullStatus(sData, mapView, refCurrentMapNode);
  
  

  
  /////////////////////////////////////////////////
  // Add a reducer data handler.
  //
  useHandleServerData(sData, mapView, refCurrentMapNode, recolorMap);
  // useHandleServerData(sData, venue, mapView, null, recolorMap);
  



  return (

    // <>
    //   <div className="livemap-page">
    //     <div className="live-map-wrap">
    //       <div id="maptarget" ref={mapHtmlTargetRef} />
    //     </div>
    //   </div>
    // </>


    <div className="livemap-page">

      <div className="live-map-wrap">

        <MapToolbarOverlay mapView={mapView} sData={props.sData} actions={props.actions} />
        <MapCameraPresetsOverlay mapView={mapView} />
        <MapLevelSelectorOverlay mapView={mapView} />

        <div id="maptarget" ref={mapHtmlTargetRef} />

      </div>

    </div>
  );

};




export default LiveMapPage;


